import React, { useContext, useState } from "react";
import { FormProvider } from "react-hook-form";
import { Button, Form, Modal } from "react-bootstrap";
import envFile from "../envFile";
import { API, graphqlOperation } from "aws-amplify";
import { crudCommunications } from "../graphql/mutations";
import { Context } from "../Utility/ContextManager";
import { SpinnerLoading } from "../components/Loadings";
import { LOGO } from "../Utility/static";

export default function EmailNotVerify() {
  const { user } = useContext(Context);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);

  const emailVerification = async () => {
    try {
      setLoading(true);
      await API.graphql(
        graphqlOperation(crudCommunications, {
          id: user?.id,
          role: "Tenant",
          code: "EMAILVERIFY",
          data: JSON.stringify({
            name: `${user?.first_name} ${user?.last_name}`,
            url: `${envFile.SIGNUP_URL}Verification/${user?.cognito_user_id}~${user?.email_verification_uuid}`,
          }),
        })
      );
      setLoading(false);
      setShow(true);
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <div className="forms">
      <div id="layout-wrapper">
        {loading && (
          <div className="loadingSpinner">
            <SpinnerLoading />
          </div>
        )}
        <div className="errors"></div>
        <div className="form-pages">
          <section className="sidebar align-items-center">
            <img src={LOGO} alt="" className="logo-img" />
          </section>
          <section className="content align-items-center justify-content-center">
            <div className="auth-form bg-white">
              <h3 className="mb-4 title">Verify your email</h3>
              <div className="mb-3 d-flex justify-content-center">
                <img src={require("../assets/images/email-not-verify.svg").default} alt="" />
              </div>
              <p className="mb-5">
                Please check your email and follow the instructions to verify your account. If you did not receive an
                email or if it expired, you can resend one.
              </p>
              <div>
                <FormProvider>
                  <Form>
                    <Button className="w-100 cursor-pointer" onClick={emailVerification}>
                      Resend
                    </Button>
                  </Form>
                </FormProvider>
              </div>
            </div>
          </section>
        </div>
      </div>
      <Modal show={show} onHide={() => setShow(false)} className="modal-v1 border-radius-16" centered>
        <Modal.Header>
          <Modal.Title as="h3" className="w-100 text-center">
            Verification Email Sent!
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center mb-3">
          A new verification link was sent to your email address. Please check your inbox and follow the instructions.
        </Modal.Body>
        <Modal.Footer>
          <Button className="w-100" onClick={() => setShow(false)}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
